import { Icons } from "../icons";
import { TagStyled } from "./styles";
export const Tag = ({ label, startIcon, endIcon, type = "normal" }) => {
  const StartIconComponent = startIcon ? Icons[startIcon] : null;
  const EndIconComponent = endIcon ? Icons[endIcon] : null;

  const colorStyles = {
    normal: {
      border: "#8C8C8C",
      background: "#EAEFF2",
      textColor: "#8C8C8C",
      iconColor: "#8C8C8C",
    },
    info: {
      border: "#0097f6",
      background: "#e3f3fd",
      textColor: "#0097f6",
      iconColor: "#0097f6",
    },
    error: {
      border: "#EA7A7A",
      background: "#FFF6F6",
      textColor: "#EA7A7A",
      iconColor: "#EA7A7A",
    },
    success: {
      border: "#34c759",
      background: "#e6f9ed",
      textColor: "#34c759",
      iconColor: "#34c759",
    },
    warning: {
      border: "#FF9500",
      background: "#FFF3E0",
      textColor: "#FF9500",
      iconColor: "#FF9500",
    },
  };

  return (
    <TagStyled colorStyles={colorStyles[type]}>
      {StartIconComponent && <StartIconComponent size={16} weight="regular" />}
      {label}
      {EndIconComponent && <EndIconComponent size={16} weight="regular" />}
    </TagStyled>
  );
};
